import { render, staticRenderFns } from "./myEmail.vue?vue&type=template&id=13a1f0eb&scoped=true&"
import script from "./myEmail.vue?vue&type=script&lang=js&"
export * from "./myEmail.vue?vue&type=script&lang=js&"
import style0 from "./myEmail.vue?vue&type=style&index=0&id=13a1f0eb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1f0eb",
  null
  
)

export default component.exports